import { render } from "./i18n-number.vue?vue&type=template&id=4ad72588&ts=true"
import script from "./i18n-number.vue?vue&type=script&lang=ts"
export * from "./i18n-number.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/shared/i18n/i18n-number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ad72588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ad72588', __exports__)) {
    api.reload('4ad72588', __exports__)
  }
  
  module.hot.accept("./i18n-number.vue?vue&type=template&id=4ad72588&ts=true", () => {
    api.rerender('4ad72588', render)
  })

}


export default __exports__